const buildFixture = (rows, totalParticipants) => {
  const summary = rows.reduce((result, row) => ({
    registeredAreaCount: result.registeredAreaCount + 1,
    unshotAreaCount: result.unshotAreaCount + (row.length === 7 ? (row[4] === 0 ? 1 : 0) : (row[5] === 0 ? 1 : 0)),
    totalRegistered: result.totalRegistered + (row.length === 7 ? row[2] : row[3]),
    totalReviewOk: result.totalReviewOk + (row.length === 7 ? row[4] : row[5]),
    totalParticipants: totalParticipants,
  }), {
    registeredAreaCount: 0,
    unshotAreaCount: 0,
    totalRegistered: 0,
    totalReviewOk: 0,
    totalParticipants,
  });

  summary.totalAchievedPercent = summary.totalRegistered
    ? Number(((summary.totalReviewOk / summary.totalRegistered) * 100).toFixed(2))
    : 0;

  return { summary, table: rows };
};

// Phase 1 fixture only. The row shape intentionally matches ByAreaDetailTable.
export const EVENT_AREA_LAYER_OPTIONS = [
  { value: "regular_1_l1", name: "都道府県" },
  { value: "regular_1_l2", name: "医療圏" },
  { value: "regular_1_l3", name: "市区町村" },
];

export const EVENT_AREA_FIXTURES = {
  regular_1_l1: buildFixture([
    [1, "宮城県", 420, 1260, 210, 1050, 83.33],
    [2, "新潟県", 280, 840, 190, 650, 77.38],
    [3, "長野県", 160, 480, 120, 360, 75.00],
  ], 284),
  regular_1_l2: buildFixture([
    [1, "仙台医療圏", "宮城県", 760, 340, 420, 55.26, 168],
    [2, "石巻医療圏", "宮城県", 500, 260, 240, 48.00, 112],
    [3, "新潟医療圏", "新潟県", 840, 190, 650, 77.38, 201],
  ], 284),
  regular_1_l3: buildFixture([
    [1, "仙台市青葉区", "宮城県", 420, 180, 240, 57.14, 102],
    [2, "石巻市", "宮城県", 340, 220, 120, 35.29, 78],
    [3, "長岡市", "新潟県", 290, 70, 220, 75.86, 96],
  ], 284),
};
